(function () {
  var SEARCH_INPUT_SELECTOR = '#SearchDrawer .search-bar__input, #rps-csb-input';
  var RESULTS_LIMIT = 5;
  var DEBOUNCE_MS = 250;

  var resultsContainer = document.createElement('div');
  resultsContainer.id = 'PredictiveSearchResults';
  resultsContainer.className = 'predictive-search-results';
  resultsContainer.hidden = true;
  document.body.appendChild(resultsContainer);

  var debounceTimer = null;
  var latestRequestId = 0;

  function positionResults(input) {
    var rect = input.getBoundingClientRect();
    resultsContainer.style.top = rect.bottom + 'px';
    resultsContainer.style.left = rect.left + 'px';
    resultsContainer.style.width = rect.width + 'px';
  }

  function clearResults() {
    resultsContainer.innerHTML = '';
    resultsContainer.hidden = true;
  }

  function formatPrice(product) {
    if (product.price_min !== product.price_max) {
      return 'From $' + product.price_min;
    }
    return '$' + product.price;
  }

  function renderResults(products, input) {
    resultsContainer.innerHTML = '';

    if (!products.length) {
      resultsContainer.hidden = true;
      return;
    }

    products.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'predictive-search-results__item';
      link.href = product.url;

      var img = document.createElement('img');
      img.className = 'predictive-search-results__image';
      img.alt = '';
      img.loading = 'lazy';
      if (product.image) {
        img.src = product.image + (product.image.indexOf('?') > -1 ? '&' : '?') + 'width=100';
      }

      var info = document.createElement('span');
      info.className = 'predictive-search-results__info';

      var title = document.createElement('span');
      title.className = 'predictive-search-results__title';
      title.textContent = product.title;

      var price = document.createElement('span');
      price.className = 'predictive-search-results__price';
      price.textContent = formatPrice(product);

      info.appendChild(title);
      info.appendChild(price);
      link.appendChild(img);
      link.appendChild(info);
      resultsContainer.appendChild(link);
    });

    positionResults(input);
    resultsContainer.hidden = false;
  }

  function fetchResults(query, input) {
    var requestId = ++latestRequestId;

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' + RESULTS_LIMIT +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (requestId !== latestRequestId) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, input);
      })
      .catch(function () {
        if (requestId === latestRequestId) clearResults();
      });
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest(SEARCH_INPUT_SELECTOR);
    if (!input) return;

    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      clearResults();
      return;
    }

    debounceTimer = setTimeout(function () {
      fetchResults(query, input);
    }, DEBOUNCE_MS);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && event.target.closest && event.target.closest(SEARCH_INPUT_SELECTOR)) {
      clearResults();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var onInput = event.target.closest && event.target.closest(SEARCH_INPUT_SELECTOR);
    if (!onInput && !resultsContainer.contains(event.target)) {
      clearResults();
    }
  });

  window.addEventListener('resize', function () {
    if (!resultsContainer.hidden) clearResults();
  });

  window.addEventListener('scroll', function () {
    if (!resultsContainer.hidden) clearResults();
  }, true);
})();
